import React, { memo, useCallback, useEffect } from 'react';

import { Container, Navigation } from '../../components';

import { __WEB__, THEME } from '../../../constants/styles';

import { useDispatch, useSelector } from 'react-redux';

import { getCurrentEmployer } from '../../../selectors/entities';
import { getCurrentUsersCase } from '../../../selectors/cases';
import { searchCases, openCaseInfo } from '../../cases/actions';
import { updatePatientFromCase, resetState } from '../../patient/actions';

import { PHASummary, ReadinessSummary } from './squad';

const Summary = memo((props) => {
  const dispatch = useDispatch();
  const employer = useSelector(getCurrentEmployer);
  const myCase = useSelector(getCurrentUsersCase);
  const squad = myCase?.group?.trim();
  const employerId = employer?.employerId;

  const handleResidentTap = useCallback(
    (caseId) => {
      dispatch(openCaseInfo(caseId));
      Navigation.showModal({
        screen: 'CaseInfo',
      });
    },
    [dispatch]
  );

  const handlePHADueSave = useCallback(
    (caseId, dueDate) => {
      console.info('>> saving due date for case', caseId, dueDate);
      let patientObj = {
        extraData: {
          pha: {
            dueDate: dueDate.toISOString(),
          },
        },
      };
      dispatch(updatePatientFromCase({ caseId, patient: patientObj }));
    },
    [dispatch]
  );

  useEffect(() => {
    if (props.screenVisible && squad && employerId) {
      dispatch(searchCases(employerId, { squadrons: [squad], limit: 1000 }));
    }
    return () => {
      dispatch(resetState());
    };
  }, [employerId, squad, props.screenVisible, dispatch]);

  return (
    <Container style={THEME.container} scrollView={true}>
      <PHASummary handleResidentTap={handleResidentTap} handlePHADueSave={handlePHADueSave} />
      <ReadinessSummary handleResidentTap={handleResidentTap} />
    </Container>
  );
});

export default Summary;
